import { Fragment, useEffect, useRef, useState } from "react";
import {
  RgbaColorPicker,
} from "react-colorful";

import { SiteData } from "../Data/SiteData";
import GearIcon from "../Icons/LightGearIcon";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import ColorPalleteMenu, { ColorLabels } from "../Menus/ColorPalleteMenu";
import VGPopUp from "../../../components/Controls/VGPopUp";

export default function CustomColorPicker({
  inColor,
  changeFunc,
  toggleOpen,
  siteData,
  showPallete = true,
  startTransparent,
  top,
  left
}: {
  inColor: string;
  changeFunc: Function;
  toggleOpen?: () => void;
  siteData: SiteData;
  startTransparent?: boolean,
  showPallete?: boolean;
  top:number;
  left:number;
}) {
  const containerRef = useRef<any>(null);
  var rgb = { r: 0, g: 0, b: 0, a: (startTransparent)?.5:1 };
  if (inColor.includes("#")) {
    rgb = hexToRGB(inColor);
  } else {

    let clr = inColor.replace("rgba(", "").replace(")", "");
    let split = clr.split(",");

    if (split.length >= 3) rgb.r = parseInt(split[0]);
    rgb.g = parseInt(split[1]);
    rgb.b = parseInt(split[2]);

    if (split.length >= 4) rgb.a = parseInt(split[3]);
  }

  const handleClick = (e: PointerEvent) => {
    if (e.target) {
      let closestContainer = (e.target as HTMLElement).closest(
        ".color-picker-container"
      );

      if (!closestContainer) {
        toggleOpen?.();
      }
    }
  };


  const onScroll = (e:any)=>{

      let scroll = e.target as HTMLElement;

      if(scroll){
        let delta =  origScrollTop.current-scroll.scrollTop;

        setNewTop(newTop+delta);
        origScrollTop.current = scroll.scrollTop;


      }

  }


  useEffect(() => {//eslint-disable-next-line
    if (containerRef.current) {//eslint-disable-next-line
      let scroll = (containerRef.current as any).closest(".nice-scroll");
      if (scroll) {
        scroll.addEventListener("scroll", onScroll);
        origScrollTop.current = scroll.scrollTop;
      }
      document.addEventListener("pointerdown", handleClick);
    }

    return () => {//eslint-disable-next-line
      if (containerRef.current) {//eslint-disable-next-line
        let scroll = (containerRef.current as HTMLElement).closest(
          ".nice-scroll"
        );

        if (scroll) {
          scroll.removeEventListener("scroll", onScroll);
        }
      }
      document.removeEventListener("pointerdown", handleClick);
    };
  });

  const updateColor = (rgb: { r: number; g: number; b: number; a: number }) => {
    let hex = rgbToHex(rgb.r, rgb.g, rgb.b, rgb.a);
    setColor(rgb);// only neccisary if we want to use a pallet as we would need to manage the color state inside this component instead of the colorField
    changeFunc(hex);
  };

  const [color, setColor] = useState(rgb);

  const origScrollTop = useRef<number>(-10);
  const [newTop,setNewTop] = useState<number>(top);




  const onSelectFromPallet = ( index:number ) => {

    if(index<0){

     
        changeFunc("");
      if(toggleOpen)
        toggleOpen();
    }

    else if (siteData) {
      let clr = siteData.siteStyling.colorPallet[index];
      let rgb = hexToRGB(clr);
      changeFunc("var(--theme-color-"+(index+1)+")");
      setColor(rgb);
    }
  }

  const eyeDrop = ()=>{

    const eyeDropper = new (window as any).EyeDropper();

    eyeDropper
      .open()
      .then((result:any ) => {
    
        setColor(hexToRGB(result.sRGBHex));
        changeFunc(result.sRGBHex)
      })
      .catch((e:any) => {
  
      });
  }

  const width = showPallete?320:220;

  let setTop = newTop;
  let setLeft = left  - width;

  if(setLeft+width+10>window.innerWidth){
    setLeft = window.innerWidth-(width+10);
  }

  if(setTop+240>window.innerHeight){
    setTop = window.innerHeight-240;
  }
  else if(setTop<20){
    setTop = 20;
  }

  const validEyeDropper = (window as any).EyeDropper;

  return (
    <div ref={containerRef} className={"color-picker-container block-edit "+(!showPallete&&validEyeDropper?"no-pallet":"")} style={{top:setTop,left:setLeft}}>
 
     {showPallete&& <SitePallet eyeDropper={eyeDrop} siteData={siteData} onSelectPallet={onSelectFromPallet}/>}
      <RgbaColorPicker color={color} onChange={updateColor} />
    {!showPallete&&validEyeDropper && 
    <button  style={{color:"#333",border:"1px solid #ccc"}} onClick={()=>{eyeDrop()}} className="w-full color-pallet-item invisible-button center-all gap-small color-picker" >
   
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#333"><path d="M199 169L233 202.9 309.1 279 343 313l8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l0 0 8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1zM53.1 329C39.6 342.5 32 360.8 32 379.9v52.9l-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28h52.9c19.1 0 37.4-7.6 50.9-21.1L313.4 328.6l-33.9-33.9L149.1 425c-4.5 4.5-10.6 7-17 7H80V379.9c0-6.4 2.5-12.5 7-17L217.4 232.6l-33.9-33.9L53.1 329z"/></svg>
    </button>
    }
    </div>
  );
}


function SitePallet({siteData,onSelectPallet,eyeDropper}:{siteData:SiteData,onSelectPallet:Function,eyeDropper:Function}){

return <div style={{padding:"0px 4px",marginRight:"8px",width:"100px",maxHeight:"200px",overflow:"auto"}}>

{(window as any).EyeDropper&&
  <button  style={{color:"#333",border:"1px solid #ccc"}} onClick={()=>{eyeDropper()}} className="color-pallet-item invisible-button center-all gap-small" >
   
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#333"><path d="M199 169L233 202.9 309.1 279 343 313l8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l0 0 8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1zM53.1 329C39.6 342.5 32 360.8 32 379.9v52.9l-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28h52.9c19.1 0 37.4-7.6 50.9-21.1L313.4 328.6l-33.9-33.9L149.1 425c-4.5 4.5-10.6 7-17 7H80V379.9c0-6.4 2.5-12.5 7-17L217.4 232.6l-33.9-33.9L53.1 329z"/></svg>
    <div className="font-small">sample</div>
    </button>
  }

    {siteData.siteStyling.colorPallet.map((color,index)=>{
;

      return <div className="color-pallet-item " style={{backgroundColor:color}} key={index}
      onClick={()=>{onSelectPallet(index)
      
     
      }}
      >
        <span><span style={{fontSize:"10px",fontStyle:"normal",marginBottom:"2px"}}></span>{ColorLabels[index]}</span>
      </div>


})}

<button style={{color:"#333",overflow:"hidden",outline:"1px solid #ccc"}} onClick={()=>{onSelectPallet(-1)}} className="color-pallet-item invisible-button center-all gap-small" >
   
   <div  style={{fontSize:"30px",color:"red"}}>&times;</div><div className="font-small">clear</div>
   </button>


  <button style={{marginTop:"7px",padding:"0"}} className="invisible-button w-full font-small hover-blue flex-row align-top gap-med" onClick={()=>{
   
  //  siteData.designer?.setState({menuState:StyleBuilderState.Colors})
  //  siteData.designer?.deselectAll();
  const PopupClose = () => {
    let dom = document.getElementById("OpenDialog");
    if (dom) unmountComponentAtNode(dom);
    siteData.designer?.forceUpdate();
   
};

  ReactDOM.render(
    <VGPopUp
      id={"color-pallete-popup"}
      show={true}
      onHide={PopupClose}
      title={"Edit Color Palette"}
      dialogClassName="block-edit"
      body={
        <div className="alertContent">
          <ColorPalleteMenu siteData={siteData} hideTitle={true} saveFunc={()=>{}}/>
        </div>
      }
      footer={
        <Fragment>
         
        <button className="w-button w-button-primary" onClick={(e) => { PopupClose();}}>Done</button>
        </Fragment >
      }
      isRemoveTabModalIndex={false}
      isShowFooter={true}
      size={"modal-sm"}
      backdrop={true}
    />,
    document.getElementById("OpenDialog"));

    }}><div style={{width:".8em"}}><GearIcon/></div> Edit Palette</button>
  </div>

}


export function hexToRGB(hex: string) {

  if(hex.length===4)//convert #fff to #ffffff
    hex = hex+hex.slice(1,4);

  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16),
    a = hex.length > 7 ? parseInt(hex.slice(7, 9), 16) / 255 : 1;

  return { r: r, g: g, b: b, a: a };
}

export function rgbToHex(r: number, g: number, b: number, a: number) {
  let hex = "#" + byteToHex(r) + byteToHex(g) + byteToHex(b);

  if (a < 1) {
    hex += byteToHex(Math.round(a * 255));
  }

  return hex;
}

function byteToHex(b: number) {
  let str = b.toString(16);
  if (str.length == 1) str = "0" + str;

  return str.substring(0, 2);
}


// function SwapIcon(){
//   return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path d="M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"/></svg>
// }

// function SwapFinalizeIcon(){

//  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
// <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>
// }

